<template>
    <div>
        <b-modal
            id="update-profile-popup"
            ref="modal"
            title="Update Profile"
            size="sm"
            modal-class="hide-footer"
            :hide-header-close="loading"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            @hidden="onHidden"
            @show="setUserDetails"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="User Name"
                            label-for="user-name"
                        >
                            <b-form-input
                                id="user-name"
                                v-model="formData.username"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    alpha_num,
                                }"
                                name="username"
                                type="text"
                                :class="{
                                    'is-invalid': errors.has('username'),
                                }"
                                autocomplete="no"
                                placeholder="Enter user name"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12 row-min-space">
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-2"
                                    label="First Name"
                                    label-for="first-name"
                                >
                                    <b-form-input
                                        id="first-name"
                                        v-model="formData.firstName"
                                        v-validate="{
                                            required: true,
                                            max: 50,
                                            alpha,
                                        }"
                                        name="first name"
                                        type="text"
                                        :class="{
                                            'is-invalid':
                                                errors.has('first name'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter first name"
                                    ></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-3"
                                    label="Last Name"
                                    label-for="last-name"
                                >
                                    <b-form-input
                                        id="last-name"
                                        v-model="formData.lastName"
                                        v-validate="{
                                            required: true,
                                            max: 50,
                                            alpha,
                                        }"
                                        name="last name"
                                        type="text"
                                        :class="{
                                            'is-invalid':
                                                errors.has('last name'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter last name"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-4"
                            label="Email Address"
                            label-for="email-address"
                        >
                            <b-form-input
                                id="email-address"
                                v-model="formData.email"
                                v-validate="{
                                    required: true,
                                    email: true,
                                }"
                                name="email"
                                type="email"
                                :class="{
                                    'is-invalid': errors.has('email'),
                                }"
                                autocomplete="no"
                                placeholder="Enter email address"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <base-upload-file-new
                            type="users"
                            :label-val="'PROFILE PICTURE'"
                            :placeholder-val="
                                formData.profilePicture.originalName
                                    ? formData.profilePicture.originalName
                                    : 'Choose image file to upload'
                            "
                            :size="10"
                            @set-value="setFileValue($event)"
                            @stop-update="stopUpdate($event)"
                            fileTypes="['image/jpeg', 'image/png']"
                        ></base-upload-file-new>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Update"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
            <base-toast></base-toast>
        </b-modal>

        <b-modal
            ref="otpmodal"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            @close="onCloseOTPModal"
        >
            <otp-verification-modal
                :hideMobile="true"
                :data="otpData"
                @verificationStatus="otpResponse"
                @reSendOTP="reSendOTP"
            ></otp-verification-modal>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CryptoJS from 'crypto-js'
import resource from '@/api/resource'
import request from '@/utils/request'
import OtpVerificationModal from '../registration/OtpVerificationModal'
const userUpdateApi = new resource('system-users/update-profile-enc')
const loginMobileNo = "11133322290"

export default {
    components: {
        OtpVerificationModal,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
            // fileTypes: ['jpeg', 'jpg', 'png', 'pdf'],
            isStopUpdate: false,
            otpData: null,
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'userId', 'hidePopup', 'user']),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > methods
    mounted() {},
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Initialize formData
         *
         * @return {formData}
         */
        initializeFormData() {
            return {
                _id: null,
                username: '',
                firstName: '',
                lastName: '',
                email: '',
                profilePicture: {
                    originalName: '',
                    fileName: '',
                },
                roleId: null,
                dataSegmentIds: [],
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            this.$refs.modal.hide()
        }, // End of onHidden() method
        onHiddenAfterOtp() {
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.otpmodal.hide()
        }, // End of onHidden() method

        stopUpdate(event) {
            this.isStopUpdate = !event ? true : false
        },
        /**
         * Handle when the modal is submit
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                if (this.isStopUpdate) {
                    let error = 'Please upload jpg/png file'
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error)
                } else {
                    let response = {}
                    try {
                        this.$store.commit('setLoading', true)

                        // this.onHidden()
                        
                        this.sendOTP(this.user);
                        

                        // response = await userUpdateApi.update(
                        //     this.formData._id,
                        //     {data: encryptedForm}
                        // )

                        // old comment start
                        // let res = CryptoJS.AES.decrypt(
                        //     response.data.data,
                        //     process.env.VUE_APP_CRYPTO_SECERT_KEY
                        // ).toString(CryptoJS.enc.Utf8)
                        // old comment end

                        // if (response) {
                        //     this.$toasted.show(response.data.message, {
                        //         duration: 2000,
                        //         type: ['success'],
                        //     })
                        //     this.onHidden()
                        //     this.$store.commit('setUser', response.data.data)
                        // }
                        // this.$store.commit('setLoading', false)
                    } catch (error) {
                        console.log('res ', response)
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', error)
                    }
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
        async setUserDetails() {
            if (this.userId) {
                let data = this.user
                this.formData._id = this.userId
                this.formData.username = data.username
                this.formData.firstName = data.firstName
                this.formData.lastName = data.lastName
                this.formData.email = data.email
                if (data.avatar) {
                    this.formData.profilePicture.originalName =
                        data.avatar.originalName
                    this.formData.profilePicture.fileName = data.avatar.fileName
                }
                this.formData.roleId = data.roleId
                this.formData.dataSegmentIds = data.dataSegmentIds
            }
        },
        setFileValue(fileObj) {
            // console.log('here ', fileObj)
            this.formData.profilePicture.fileName = fileObj.fileName
            this.formData.profilePicture.originalName = fileObj.originalName
        },
        async sendOTP(profileData) {
            try {
                let fullName = profileData.firstName
                let email = profileData.email
                let recieveOtpOption = ['email']

                // let dataSegmentId = this.dataSegmentId

                this.$store.commit('setLoading', true)

                const formData = {
                    name: fullName,
                    email: email,
                    mobileNo: loginMobileNo,
                    key: 'updateProfileOtp',
                    recieveOtpOption: recieveOtpOption,
                }
                let encryptedForm = this.CryptoJS.AES.encrypt(
                    JSON.stringify(formData),
                    process.env.VUE_APP_CRYPTO_SECERT_KEY
                ).toString()

                // console.log('PHONE NUMBER: ' + phoneNumber)

                const { data } = await request({
                    url: `/configurations/generate-otp-enc/`,
                    method: 'post',
                    data: {data: encryptedForm},
                })
                // console.log("dataOTPGET ", JSON.stringify(data));
                if (data) {
                    this.$refs.modal.hide()
                    this.otpData = {...data, data: {...data.data, phoneNumber: loginMobileNo,}}
                    this.$nextTick(()=> {
                        this.$refs.otpmodal.show()
                    })
                }

                // this.showPageLoader = false
                // console.log('Response OTP data: ' + JSON.stringify(data))
                // this.fields = data.data
            } catch (error) {
                console.log('OTP error: ' + error)
                const message = error.response ?  error.response.data ?error.response.data.message : '' : ''
                this.$store.commit('setError', message || 'Invalid OTP' )
            }

            this.$store.commit('setLoading', false)
        }, // End of sendOtp() method
        async otpResponse(data, otp) {

                console.log("emi otp data: " + JSON.stringify(data));

                this.$store.commit('setLoading', true)

                if (data.verificationStatus == true) {
                    this.$store.commit('setLoading', true)

                    // this.$store.commit('setSuccess', 'Login successfull.')
                    // this.$store.commit('setToken', this.loginResponse.accessToken)
                    // this.$store.commit('setUser', this.loginResponse.profile)
                    // this.$store.commit('setLoading', false)
                    
                try {
                    let encryptedForm = this.CryptoJS.AES.encrypt(
                                JSON.stringify(this.formData),
                                process.env.VUE_APP_CRYPTO_SECERT_KEY
                            ).toString()
                    const response = await userUpdateApi.update(
                            this.formData._id,
                            {data: encryptedForm}
                        )

                        if (response) {
                            this.$toasted.show(response.data.message, {
                                duration: 2000,
                                type: ['success'],
                            })

                            const newUser = {...response.data.data, roleId: this.user.roleId} // since roleId will not be returned in api
                            this.$store.commit('setUser', newUser)
                            this.onHiddenAfterOtp()
                        }
                        this.$store.commit('setLoading', false)
                    }catch (error) {
                        console.log('error', error)
                        this.$store.commit('setLoading', false)
                        let message = typeof error == 'string' ? error : error.message;
                        this.$store.commit('setError', message)

                        this.$refs.otpmodal.hide()
                        this.$refs.modal.show()
                    }
                } else {
                    this.$store.commit('setError', data.message)
                    this.$store.commit('setLoading', false)
                }
            
        },

        async reSendOTP() {
            this.sendOTP(this.user)
        }, // End of reSendOTP() method
        onCloseOTPModal() {
            this.$store.commit('setLoading', false)
        }, // End of onCloseOTPModal() method
    }, // End of Component > mounted
}
</script>
